function getRedValue(color) {
  return parseInt(color.substring(0, 2), 16);
}
function getGreenValue(color) {
  return parseInt(color.substring(2, 4), 16);
}
function getBlueValue(color) {
  return parseInt(color.substring(4, 6), 16);
}
const COLOR_THRESHOLD = 256 / 2; // Lower threshold equals more dark text on dark background
const RED_YIQ_FACTOR = 299;
const GREEN_YIQ_FACTOR = 587;
const BLUE_YIQ_FACTOR = 114;
function getContrastHex(color) {
  const intColor = color.replace('#', '');
  const redBrightness = getRedValue(intColor) * RED_YIQ_FACTOR;
  const greenBrightness = getGreenValue(intColor) * GREEN_YIQ_FACTOR;
  const blueBrightness = getBlueValue(intColor) * BLUE_YIQ_FACTOR;
  const colorBrightness = (redBrightness + greenBrightness + blueBrightness) / 1000;
  return colorBrightness > COLOR_THRESHOLD ? '--neutral-text-high-emphasis' : '--neutral-text-inverse';
}
export default getContrastHex;